import React from "react";
import styled, { css } from "styled-components";
import StackedButton from "@common/LifeAtButton/Variants/StackedButton";
import LifeAtButtonWithDropdown from "@common/LifeAtButtonWithDropdown/LifeAtButtonWithDropdown";

const DropdownItem = styled(StackedButton)<{ active: boolean }>`
    ${({ active }) =>
        active &&
        css`
            color: ${({ theme }) => theme.textColorSpecial};
        `}
`;

interface InputDeviceControlProps {
    icon: React.ReactNode;
    label: string;
    devices: MediaDeviceInfo[];
    selectedDevice: MediaDeviceInfo | null;
    onToggle?: () => void;
    onSelect?: (device: MediaDeviceInfo) => void;
    className?: string;
}

export default function InputDeviceControl(props: InputDeviceControlProps) {
    return (
        <LifeAtButtonWithDropdown
            className={props.className}
            label={props.label}
            icon={props.icon}
            onClick={props.onToggle}
            dropdown={props.devices.map((device) => (
                <DropdownItem
                    active={props.selectedDevice?.deviceId === device.deviceId}
                    key={device.deviceId}
                    label={device.label}
                    action={"click"}
                    handleClick={() => props.onSelect?.(device)}
                />
            ))}
        />
    );
}
